var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarCollapse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.7 4.8C5.20294 4.8 4.8 5.20294 4.8 5.7V18.3C4.8 18.7971 5.20294 19.2 5.7 19.2H18.3C18.7971 19.2 19.2 18.7971 19.2 18.3V5.7C19.2 5.20294 18.7971 4.8 18.3 4.8H5.7ZM5.7 3H18.3C19.7912 3 21 4.20881 21 5.7V18.3C21 19.7912 19.7912 21 18.3 21H5.7C4.20881 21 3 19.7912 3 18.3V5.7C3 4.20881 4.20881 3 5.7 3Z",
    fill: "#D8D6D4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 3.9C8 3.40294 8.44771 3 9 3C9.55229 3 10 3.40294 10 3.9V20.1C10 20.5971 9.55229 21 9 21C8.44771 21 8 20.5971 8 20.1V3.9Z",
    fill: "#D8D6D4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7071 9.29289C16.0976 9.68342 16.0976 10.3166 15.7071 10.7071L14.4142 12L15.7071 13.2929C16.0976 13.6834 16.0976 14.3166 15.7071 14.7071C15.3166 15.0976 14.6834 15.0976 14.2929 14.7071L12.2929 12.7071C11.9024 12.3166 11.9024 11.6834 12.2929 11.2929L14.2929 9.29289C14.6834 8.90237 15.3166 8.90237 15.7071 9.29289Z",
    fill: "#D8D6D4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarCollapse);
export default __webpack_public_path__ + "static/media/sidebar-collapse.ee10de7a3028168a94db753f0adcb96d.svg";
export { ForwardRef as ReactComponent };